import React, { Component } from "react";
import "../../Styles/ElivatedRiskManagement.scss";
import Images from "../../Assets/Images";

export default class TenantElivation extends Component {
  render() {
    return (
      <div className="appCont">
        <div className="mainWrapper">
          {/* Elivated Risk */}
          <div className="elivatedRiskCont">
            <div className="elWrapper">
              <div className="elLeftBox">
                <div className="card">
                  <h4>Elevated Risk Management</h4>
                  <ul>
                    <li>
                      <h5>Risk Number</h5>
                      <p>ANG-RSK-02</p>
                    </li>
                    <li>
                      <h5>Project</h5>
                      <p>Angolan Offshore Field</p>
                    </li>
                    <li>
                      <h5>Risk Description</h5>
                      <p>
                        There is a risk that reinjection rates may not be
                        achieved
                      </p>
                    </li>
                    <li>
                      <h5>Cause</h5>
                      <p>Plant performances out of specification</p>
                    </li>
                    <li>
                      <h5>Frequency</h5>
                      <p>10.00%</p>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="elRightBox">
                <div className="card">
                  <div className="cardHeader tabCont">
                    <ul>
                      <li className="active">
                        <a>Stakeholder Assignment</a>
                      </li>
                      <li>
                        <a>
                          Root Causes
                          <span>0</span>
                        </a>
                      </li>
                      <li>
                        <a>
                          Actions
                          <span>0</span>
                        </a>
                      </li>
                      <li>
                        <a>Solution</a>
                      </li>
                    </ul>
                  </div>

                  <div className="approverCont">
                    <form>
                      <h5>Approvers</h5>
                      <div className="formContainer ">
                        <div className="row">
                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="fieldCont">
                              <label>Project Manager</label>
                              <select>
                                <option>Cameron Williamson</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="fieldCont">
                              <label>Finance Manager</label>
                              <select>
                                <option>Darrell Steward</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="fieldCont">
                              <label>Engineering Manager</label>
                              <select>
                                <option>Guy Hawkins</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="fieldCont">
                              <label>Risk Manager</label>
                              <select>
                                <option>Esther Howard</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="fieldCont">
                              <label>PMO</label>
                              <select>
                                <option>Brooklyn Simmons</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <h5>Team Members</h5>
                      <div className="formContainer ">
                        <div className="row">
                          <div className="col-xs-12 col-sm-12">
                            <div className="fieldCont">
                              <select>
                                <option>Robert Fox</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="formBtn">
                    <button>Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rightSidebar ml-auto ">
          <h3>ANG-RSK-02</h3>
          <div className="gridHeader">
            <div className="d-flex align-items-center">
              <h4>My Actions</h4>
              <div className="ml-auto">
                <div className="searchBox">
                  <span className="searchIcon">
                    <img src={Images.SEARCHICON} width="12" alt="Search" />
                  </span>
                  <input type="text" placeholder="Search" name="search" />
                </div>
              </div>
            </div>
          </div>

          <div className="dropDownCont">
            <div className="ddLabel d-flex">
              <label>ANG-RSK-02-1</label>
              <span className="ml-auto">
                <img src={Images.EXPAND} alt="Expand" />
              </span>
            </div>
          </div>

          <div className="dropDownCont opened">
            <div className="ddLabel d-flex">
              <label>ANG-RSK-02-2</label>
              <span className="ml-auto">
                <img src={Images.EXPAND} alt="Expand" />
              </span>
            </div>
            <div className="expandedCont">
              <div className="btnGroup d-flex">
                <div className="btnCont">
                  <button>Edit Action</button>
                </div>
                <div className="btnCont">
                  <button>View Sub-Action</button>
                </div>
              </div>

              <ul className="mitiList">
                <li>
                  <h5>Approved</h5>
                  <p>Yes</p>
                </li>
                <li>
                  <h5>Control</h5>
                  <p>Undertake further design work</p>
                </li>
                <li>
                  <h5>Owner</h5>
                  <p>Joe Bloggs</p>
                </li>
                <li>
                  <h5>Cost</h5>
                  <p>$2,000.00</p>
                </li>
                <li>
                  <h5>Red. Frequency</h5>
                  <p>5.00%</p>
                </li>
                <li>
                  <h5>Red. Production Loss ($ boe/day)</h5>
                  <p>-5,000,000.00</p>
                </li>
                <li>
                  <h5>Red. Project Cost Increase ($)</h5>
                  <p>-5,000,000.00</p>
                </li>
                <li>
                  <h5>Red. Project Duration Increase (days)</h5>
                  <p>-100.00</p>
                </li>
                <li>
                  <h5>Red. Share Price Reduction (%)</h5>
                  <p>-0.01</p>
                </li>
                <li>
                  <h5>SPI</h5>
                  <p>0.8</p>
                </li>
                <li>
                  <h5>Original Completion</h5>
                  <p>24/08/20</p>
                </li>
                <li>
                  <h5>Projected Completion</h5>
                  <p>24/08/20</p>
                </li>
                <li>
                  <h5>Actual Completion</h5>
                  <p>--</p>
                </li>
                <li>
                  <h5>Status</h5>
                  <p>--</p>
                </li>
                <li>
                  <h5>Author</h5>
                  <p>--</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
